import { put, select, takeEvery } from 'redux-saga/effects';
import { Selectors as RouterSelectors, Types as RouterTypes } from 'router';

export interface ClearWatchOptions {
  urlParam: string;
}

type ClearAction = () => any;

function* triggerRequest(clear: ClearAction, options: ClearWatchOptions, signIn: boolean) {
  const id = yield select(RouterSelectors.getParam, options.urlParam);
  const lastid = sessionStorage.getItem(`last-clear-${options.urlParam}`) || 'noKey';

  if (id !== lastid) {
    sessionStorage.setItem(`last-clear-${options.urlParam}`, id);
    yield put(clear());
  }
}

export function newClearWatchSaga(clear: ClearAction, options: ClearWatchOptions) {
  return function*() {
    yield takeEvery(RouterTypes.LOCATION_CHANGED, () => triggerRequest(clear, options, false));
  };
}
